/* Lovable Collection / Category page interactions */
(function () {
  function init(root) {
    if (!root || root.__lvcInit) return;
    root.__lvcInit = true;

    /* ---------- intro read-more ---------- */
    var introToggle = root.querySelector("[data-intro-toggle]");
    var introMore = root.querySelector("[data-intro-more]");
    var introLabel = root.querySelector("[data-intro-label]");
    var intro = root.querySelector("[data-intro]");
    if (introToggle && introMore) {
      introToggle.addEventListener("click", function () {
        var open = introMore.hasAttribute("hidden");
        if (open) {
          introMore.removeAttribute("hidden");
          introToggle.setAttribute("aria-expanded", "true");
          if (introLabel) introLabel.textContent = "Weniger anzeigen";
          if (intro) intro.classList.add("is-open");
        } else {
          introMore.setAttribute("hidden", "");
          introToggle.setAttribute("aria-expanded", "false");
          if (introLabel) introLabel.textContent = "Weiterlesen";
          if (intro) intro.classList.remove("is-open");
          if (intro) requestAnimationFrame(function () { intro.scrollIntoView({ behavior: "smooth", block: "start" }); });
        }
      });
    }

    /* ---------- category strip arrow ---------- */
    var strip = root.querySelector("[data-strip] .lvc-strip__grid");
    var stripNext = root.querySelector("[data-strip-next]");
    if (strip && stripNext) {
      var syncArrow = function () {
        var overflow = strip.scrollWidth - strip.clientWidth;
        if (overflow <= 4) stripNext.setAttribute("hidden", "");
        else stripNext.removeAttribute("hidden");
      };
      stripNext.addEventListener("click", function () {
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        if (atEnd) strip.scrollTo({ left: 0, behavior: "smooth" });
        else strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: "smooth" });
      });
      window.addEventListener("resize", syncArrow);
      if (window.ResizeObserver) { new ResizeObserver(syncArrow).observe(strip); }
      syncArrow();
    }

    /* ---------- filter + sort ---------- */
    var grid = root.querySelector("[data-grid]");
    var priceSel = root.querySelector("[data-filter-price]");
    var availSel = root.querySelector("[data-filter-avail]");
    var sortSel = root.querySelector("[data-sort]");
    var countEl = root.querySelector("[data-count]");
    var noResults = root.querySelector("[data-noresults]");

    if (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-card]"));
      var apply = function () {
        var pf = priceSel ? priceSel.value : "";
        var af = availSel ? availSel.value : "";
        var sort = sortSel ? sortSel.value : "featured";
        var shown = 0;

        cards.forEach(function (c) {
          var price = parseInt(c.getAttribute("data-price"), 10) || 0; // cents
          var onSale = c.getAttribute("data-sale") === "1";
          var best = c.getAttribute("data-bestseller") === "1";
          var ok = true;
          if (pf === "u20") ok = ok && price < 2000;
          else if (pf === "20-40") ok = ok && price >= 2000 && price <= 4000;
          else if (pf === "o40") ok = ok && price > 4000;
          if (af === "sale") ok = ok && onSale;
          else if (af === "bestseller") ok = ok && best;
          c.style.display = ok ? "" : "none";
          if (ok) shown++;
        });

        // sort the visible cards
        var visible = cards.filter(function (c) { return c.style.display !== "none"; });
        if (sort === "price-asc") visible.sort(function (a, b) { return (a.getAttribute("data-price") - b.getAttribute("data-price")); });
        else if (sort === "price-desc") visible.sort(function (a, b) { return (b.getAttribute("data-price") - a.getAttribute("data-price")); });
        else if (sort === "name") visible.sort(function (a, b) { return (a.getAttribute("data-name") || "").localeCompare(b.getAttribute("data-name") || "", "de"); });
        visible.forEach(function (c) { grid.appendChild(c); });

        if (countEl) countEl.textContent = shown;
        if (noResults) { if (shown === 0) noResults.removeAttribute("hidden"); else noResults.setAttribute("hidden", ""); }
      };
      if (priceSel) priceSel.addEventListener("change", apply);
      if (availSel) availSel.addEventListener("change", apply);
      if (sortSel) sortSel.addEventListener("change", apply);
    }

    /* ---------- scroll to top ---------- */
    var toTop = root.querySelector("[data-totop]");
    if (toTop) {
      var onScroll = function () { toTop.classList.toggle("is-visible", window.scrollY > 400); };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
    }
  }

  function boot() {
    document.querySelectorAll(".lvc").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector ? e.target.querySelector(".lvc") : null;
    if (el) init(el);
  });
})();
